<script setup>
import { onMounted, ref, watch, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { useAssessmentsStore } from '../stores';
import AssessmentCard from './AssessmentCard.vue';
import iconArrowLeft from '~/assets/icon_arrow_left.svg'

const route = useRoute()
const assessmentStore = useAssessmentsStore()
const assessmentData = ref(null)
const currentChild = ref({})

const slideIndex = ref(0)
const router = useRouter()
watch(route, async (to, prev) => {
    if (to.path.includes('readiness/assessment') && to.params.id) {
        await configureAssessmentData(to.params.id)
    }
})


const configureAssessmentData = async (assessmentId) => {
    if (!assessmentStore.readinessAssessments[assessmentId] || !assessmentStore.readinessAssessments[assessmentId].assessment_milestones) {
        await assessmentStore.fetchAssessmentById(assessmentId)
    }
    const assessmentReportCardId = assessmentStore.readinessAssessments[assessmentId].readiness_report_card_id
    assessmentData.value = assessmentStore.readinessAssessments[assessmentId]

    // set current child from RRC if deep linked 
    currentChild.value = assessmentStore.readinessReportCards[assessmentReportCardId].child
}

const nextSlide = () => {
    if (slideIndex.value !== 0 && slideIndex.value !== assessmentData.value.assessment_milestones.length - 1) {
        // readinessAreas.value[Object.keys(readinessAreas.value)[currentSlide.value - 1]].completed = true
    }
    if (slideIndex.value < assessmentData.value.assessment_milestones.length) {
        slideIndex.value += 1
    }
}

const previousSlide = () => {
    if (slideIndex.value >= 1) {
        slideIndex.value -= 1
    } else {
        slideIndex.value = 0
    }
}

onMounted(async () => {
    await configureAssessmentData(route.params.id)
})

const screenTitle = computed(() => {
    if (assessmentData.value) {
        return assessmentData.value.readiness_area.attributes.title.replace('Development', 'Milestones')
    } else {
        return ''
    }
})

const assessmentNote = computed(() => {
    if (assessmentData.value && assessmentData.value.assessment_notes) {
        const filtered = assessmentData.value.assessment_notes.filter(note => note.assessment_milestone_id === null)
        return filtered.length ? filtered[0] : null
    } else return null
})

const mappedMilestones = computed(() => {
    // TODO: consolidate before making changes
    if (assessmentData.value) {
        const notesMap = assessmentData.value.assessment_notes ? assessmentData.value.assessment_notes.reduce((accum, curr) => {
            accum[curr.assessment_milestone_id] = curr
            return accum
        }, {}) : {}
        return assessmentData.value.assessment_milestones.map(milestone => {
            return {
                milestone,
                note: notesMap[milestone.id]
            }
        })
    }
})
</script>
<template>
    <div class="mx-2 mt-2">
        <div class="flex flex-col justify-center content-center">
            <div
                class="block w-96 max-w-md bg-white  rounded-xl shadow-md flex flex-col justify-start content-center items-center mb-2 w-full">
                <div class="overflow-hidden w-full px-4" v-if="assessmentData">
                    <div class="flex flex-row">
                        <img class="w-6 h-6 justify-self-end cursor-pointer mt-2 mr-2" aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" :src="iconArrowLeft"
                            @click="router.push(`/readiness/report-card/${assessmentData.readiness_report_card_id}`)" />
                        <h5 class="text-lg tracking-tight text-secondary text-center font-card py-1.5">
                            {{ screenTitle }}
                        </h5>
                    </div>
                    <div class="text-sm" v-if="slideIndex < assessmentData.assessment_milestones.length">
                        For each of these questions, ask yourself if {{ currentChild.first_name }}
                        exhibits each of these skills at least 75% of the time.</div>
                    <div v-else class="text-sm">Any last comments to add? This could be changes in behavior or interesting
                        new habits.</div>
                    <AssessmentCard v-for="mappedMS, idx in mappedMilestones" v-show="idx === slideIndex"
                        :milestone-id="mappedMS.milestone.id"
                        :milestone-text="mappedMS.milestone.readiness_milestone.question_form"
                        :milestone-achievement="mappedMS.milestone.achievement_level" :note="mappedMS.note"
                        :first="idx === 0" :last="false" :assessment-id="`${parseInt(assessmentData.id)}`"
                        @previous="previousSlide" @next="nextSlide" />
                    <AssessmentCard v-show="slideIndex === mappedMilestones.length" v-if="mappedMilestones"
                        :note="assessmentNote" :assessment-id="`${parseInt(assessmentData.id)}`" @previous="previousSlide"
                        @next="router.push(`/readiness/report-card/${assessmentData.readiness_report_card_id}`)"
                        :last="true" />
                </div>
            </div>

            <!-- <div class="absolute z-30 flex space-x-3 -translate-x-1/2 bottom-28 left-1/2" v-if="assessmentData"> -->
            <div class="flex flex-row justify-center my-4" v-if="assessmentData">
                <button :id="`carousel-indicator-${item}`" type="button" @click="slideIndex = item"
                    v-for="item in Array(assessmentData.assessment_milestones.length + 1).keys()"
                    :class="slideIndex === item ? 'bg-secondary' : 'border border-secondary'"
                    class="w-3 h-3 rounded-full group-hover:bg-teal-300 mx-1"></button>
            </div>

        </div>
    </div>
</template>